import type { BranchDay, BranchHours } from "@workspace/api-client-react";
import { cn } from "@/lib/utils";
import { DAY_LABELS, DAY_ORDER } from "./formatOpenNow";

function todayIn(timezone: string | null): BranchDay | null {
  try {
    const wd = new Intl.DateTimeFormat("en-US", { weekday: "short", timeZone: timezone ?? undefined })
      .format(new Date()).toLowerCase().slice(0, 3);
    return (DAY_ORDER as string[]).includes(wd) ? (wd as BranchDay) : null;
  } catch {
    return null;
  }
}

export function OpeningHours({ hours, timezone }: { hours: BranchHours | null; timezone: string | null }) {
  if (!hours) return null;
  const today = todayIn(timezone);
  return (
    <table className="w-full text-sm">
      <caption className="sr-only">Opening hours</caption>
      <thead className="sr-only">
        <tr><th scope="col">Day</th><th scope="col">Hours</th></tr>
      </thead>
      <tbody>
        {DAY_ORDER.map((day) => {
          const ranges = hours[day];
          const isToday = day === today;
          return (
            <tr key={day} className={cn("border-b border-border last:border-0", isToday && "font-semibold")}
              aria-current={isToday ? "date" : undefined}>
              <th scope="row" className="py-2 pr-4 text-left font-inherit">
                {DAY_LABELS[day]}{isToday && <span className="ml-1 text-muted-foreground">(today)</span>}
              </th>
              <td className="py-2 text-right">
                {ranges && ranges.length ? ranges.map(([a, b]) => `${a}–${b}`).join(", ") : "Closed"}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}
